// api methods enum
export enum DoorStatuses {
  OPENED = 'OPENED',
  CLOSED = 'CLOSED',
  LOCKED = 'LOCKED',
}
